import { defaultTitle, defaultSubtitle, defaultItems } from '@pages/Forbidden/Forbidden.constants';
import { Forbidden } from '@pages/Forbidden/Forbidden';
import { FallbackProps } from 'react-error-boundary';

// Defensive fallback: avoid hooks requiring providers because an error can occur before providers mount
export const FallbackToplevel = ({ error }: FallbackProps) => {
  // Derive path safely without React Router (may not be mounted if crash happened early)
  const pathname = typeof window !== 'undefined' ? window.location.pathname : '/';
  const isHomePage = pathname === '/';

  // Log original error for diagnostics
  console.error('App crashed – rendering top-level fallback', error);

  const safeSignOut = async () => {
    try {
      // Okta context might not exist; attempt global reference if available

      const maybeOkta: any = (window as any)?.oktaAuth || (window as any)?.okta?.oktaAuth;
      if (maybeOkta?.signOut) {
        await maybeOkta.signOut();
      } else {
        // As a last resort navigate to root to trigger a fresh auth flow
        window.location.href = '/';
      }
    } catch (e) {
      console.error('Fallback signOut failed', e);
      window.location.href = '/';
    }
  };

  return (
    <Forbidden
      title={defaultTitle}
      subtitle={defaultSubtitle}
      items={defaultItems}
      primaryBtnText={isHomePage ? undefined : 'Continue to your Homepage'}
      primaryBtnRedirect={isHomePage ? undefined : '/'}
      secondaryBtnText='Log out'
      secondaryBtnAction={safeSignOut}
    />
  );
};
